module.exports = __webpack_public_path__ + "static/media/14UNEP19.99c6c506.jpg";